import urlToImage from '@quicktools/shared-components/utils/urlToImage';
import bytesToSize from '@quicktools/shared-components/utils/bytesToSize';
import { IFile } from '@quicktools/shared-components/hooks/fileConverterBase/types';

import { resultType } from '../configs';

export default async function convert({ url }: IFile): Promise<{ url: string; size: string }> {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw 'Canvas ctx not supported';
  }

  const img = await urlToImage(url);

  canvas.width = img.width;
  canvas.height = img.height;

  ctx.drawImage(img, 0, 0);

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        return resolve({
          url: URL.createObjectURL(blob),
          size: bytesToSize(blob.size),
        });
      }
      reject('no blob');
    }, resultType);
  });
}
